export const BURNUP_REPORT = 'burnup';
export const BURNDOWN_REPORT = 'sprintBurndownChart';
export const CUMULATIVE_FLOW_DIAGRAM = 'cumulativeFlowDiagram';
export const VELOCITY_REPORT = 'velocityReport';
